import CustomizedButton from '../CustomizedButton';
import { ICustomizedButtonProps } from '../types';

interface Props extends ICustomizedButtonProps {}

const ModalButton = ({ size = 'large', ...props }: Props) => {
  return <CustomizedButton {...props} size="large" fullWidth />;
};

export default ModalButton;
